<template>
  <b-card no-body>
    <b-card-header>开发者设置</b-card-header>
    <b-card-body>
      <div class="my-3">
        <b-button
          href="#"
          variant="primary"
          style="min-width: 80px;"
          @click="editable=!editable"
        >{{ editable?"取消":"编辑" }}</b-button>
        <b-button
          href="#"
          variant="danger"
          style="min-width: 80px;"
          class="mx-3"
          :disabled="!editable"
          @click="saveConfig"
        >保存</b-button>
        <p class="d-inline">谨慎使用，除非你知道到底在做什么</p>
      </div>
      <b-form-textarea
        id="textarea"
        v-model="config"
        placeholder="Enter something..."
        rows="50"
        :disabled="!editable"
      ></b-form-textarea>
    </b-card-body>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      config: "default info",
      admin_password_old: "",
      editable: false
    };
  },
  created: function() {
    let _this = this;
    this.$prompt({
      message:
        "为保护关键信息，请输入管理员密码。（密码验证成功后，所有配置信息将以明文显示）",
      title: "安全验证",
      cancelTitle: "取消",
      okTitle: "确定",
      ok: pass => {
        _this.common.axios
          .post("./admin/ajax/setting/config", { password: pass })
          .then(e => {
            console.log(e.data);
            _this.admin_password_old = pass;
            _this.config = JSON.stringify(e.data, null, 2);
          })
          .catch(e => {
            _this.config = JSON.stringify(e);
          });
      },
      cancel: () => {
        _this.config = "验证取消";
      },
      close: () => {
        _this.config = "验证取消";
      }
    });
  },
  methods: {
    saveConfig() {
      let c;
      try {
        c = JSON.parse(this.config);
        if (!c.G_CONFIG || !c.DRIVE_MAP) return alert("invalid config");
      } catch (e) {
        return alert("invalid json");
      }
      c.G_CONFIG.admin_password_old = this.admin_password_old;
      this.common.axios
        .post("./admin/ajax/save", c)
        .then(r => {
          alert(r.data.info);
        })
        .catch(e => {
          console.log(e);
          alert("failed");
        });
    }
  }
};
</script>